import { ObservableFromFetch } from "../ObservableFromFetch"

export interface OrderDefault {
  OrderDefaultID?: number
  ImplementationID: number
  AccountID?: number
  LookupCode: string
  FieldName: string
  DefaultValue?: string
  Show: boolean
  IsDefault: boolean
  Disable: boolean
}

export interface SaveOrderDefaults {
  Defaults: OrderDefault[]
}

interface GetResetDefaults {
  ImplementationID: number,
  AccountID?: number | string,
  LookupCode: string
}

export default function OrderDefaultsGet(data: GetResetDefaults) {
  const requestBody: string = JSON.stringify(data)
  return ObservableFromFetch<OrderDefault[]>("WorkforceOrder/GetOrderDefaults", requestBody)
}

export function OrderDefaultsSave(data: SaveOrderDefaults) {
  const requestBody: string = JSON.stringify(data)
  return ObservableFromFetch<string>("WorkforceOrder/SaveOrderDefaults", requestBody )
}

export function OrderDefaultsReset(data: GetResetDefaults)  {
  const requestBody: string = JSON.stringify(data)
  return ObservableFromFetch<string>("WorkforceOrder/ResetOrderDefaults", requestBody )
}